import { render, staticRenderFns } from "./CustomerSVG.vue?vue&type=template&id=342dd49e&scoped=true"
import script from "./CustomerSVG.vue?vue&type=script&lang=js"
export * from "./CustomerSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342dd49e",
  null
  
)

export default component.exports